<!-- loading弹层 -->
<template>
  <div class="loading-pop" v-show="load.show">
    <img src="../../assets/images/loading.gif" alt="">
    <div v-text="load.txt"></div>
  </div>
</template>
<script>
export default {
  name: 'load',
  data () {
    return {
      // 可以根据实际情况写更复杂的弹层，根据情况扩充load即可
      load: {
        show: '',
        txt: ''
      }
    }
  },
  created () {
    this.bus.$on('load', (data) => {
      this.load = data
    })
  }
}
</script>
<style scoped lang='less'>
@import "../../assets/less/mixin.less";
.loading-pop{
  position: fixed;
  overflow-y: hidden;
  width: 100%;
  left: 0;
  top: 0;
  background: rgba(0,0,0,0.6);
  z-index: 9998;
  height: 40rem;
  padding-top: 60%;
  text-align: center;
  color: @white;
  font-size: 0.3rem;
  img{
    width: 1rem;
    padding-bottom: 0.2rem;
    display: inline-block;
  }
}
/*横屏less*/
@media screen and (min-width: 600px) {
  .loading-pop{
    padding-top: 15%;
    font-size: 0.2rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/loading.vue